import * as providers from './provider'

export default setHome => {
  const fetchBanner = async () => {
    setHome(prev => ({
      ...prev,
      bannersStatus: 'loading',
    }))

    const [bannerImageError, bannerImageResult] = await providers.bannerImage()

    if (bannerImageError) {
      // eslint-disable-next-line no-console
      console.error('Erro ao buscar imagem do banner', bannerImageError)
      return
    }
    const [
      advertisingDataError,
      advertisingDataResult,
    ] = await providers.advertisingData()

    if (advertisingDataError) {
      // eslint-disable-next-line no-console
      console.error('Erro ao buscar dados da propraganda', advertisingDataError)
      return
    }

    const advertising = {
      urlDesktop: advertisingDataResult.data.url_desktop,
      urlMobile: advertisingDataResult.data.url_mobile,
      link: advertisingDataResult.data.link,
    }

    setHome(prev => ({
      ...prev,
      banners: bannerImageResult.data,
      advertising,
      bannersStatus: 'loaded',
    }))
  }

  const fetchBestSellingProperty = async () => {
    setHome(prev => ({
      ...prev,
      bestSellersLoading: true,
    }))

    const [error, result] = await providers.fetchBestSellingProperty()

    if (error) {
      setHome(prev => ({
        ...prev,
        bestSellersLoading: false,
        bestSellersErr: true,
      }))
      // eslint-disable-next-line no-console
      return console.error('Erro ao buscar imagem do banner', error)
    }

    return setHome(prev => ({
      ...prev,
      bestSellersLoading: false,
      bestSellers:
        (result &&
          result.data &&
          result.data.data &&
          result.data.data.splice(0, 4)) ||
        [],
    }))
  }

  return {
    fetchBanner,
    fetchBestSellingProperty,
  }
}
